let modal;
var initMunchSplide = false;
var initKoreaSplide = false;
var initMeixcoSplide = false;
var initRamenSplide = false;
document.addEventListener("click", (e) => {
    if (e.target.classList.contains('modal-open')) {
        modal = document.getElementById(e.target.dataset.id);
        openModal(modal);
        dataLayer.push({'event': 'modalOpen', 'label': e.target.dataset.label ? e.target.dataset.label : '' });
    } else if (e.target.classList.contains("modal-close") || e.target.classList.contains("modal-close-btn")) {
        closeModal(modal);
    } else if (e.target.classList.contains('modal')) {
        closeModal(modal);
    } else {
        return;
    }

    if (e.target.classList.contains('modal-open') && e.target.getAttribute('data-id') == 'munch-box-modal') {
        // var subscribeslider = document.getElementsByClassName('munch-box-slider');
        // if (subscribeslider.length > 0 && !initMunchSplide) {
        //     new Splide('.munch-box-slider', {
        //         autoplay: false,
        //         type: 'slide',
        //         width: '100%',
        //         fixedHeight: 480,
        //         gap: 0,
        //         pagination: true,
        //         perPage: 1,
        //         focus: 'center',
        //         trimSpace: true,
        //         arrows: false,
        //         cover: true,
        //         rewind: true,
        //         breakpoints: {
        //             749: {
        //                 trimSpace: false,
        //                 fixedHeight: 375,
        //                 pagination: true
        //             }
        //         }
        //     }).mount();
        //     initMunchSplide = true;
        // }
        window.dispatchEvent(new Event('resize'));
    }

    if (e.target.classList.contains('modal-open') && e.target.getAttribute('data-id') == 'korea-box-modal') {
        var subscribeslider = document.getElementsByClassName('korea-box-slider');
        if (subscribeslider.length > 0 && !initKoreaSplide) {
            // new Splide('.korea-box-slider', {
            //     autoplay: false,
            //     type: 'slide',
            //     width: '100%',
            //     fixedHeight: 480,
            //     gap: 0,
            //     pagination: true,
            //     perPage: 1,
            //     focus: 'center',
            //     trimSpace: true,
            //     arrows: false,
            //     cover: true,
            //     rewind: true,
            //     breakpoints: {
            //         749: {
            //             trimSpace: false,
            //             fixedHeight: 375,
            //             pagination: true
            //         }
            //     }
            // }).mount();
            // initKoreaSplide = true;
        }
        window.dispatchEvent(new Event('resize'));
    }


    if (e.target.classList.contains('modal-open') && e.target.getAttribute('data-id') == 'mexico-box-modal') {
        var subscribeslider = document.getElementsByClassName('mexico-box-slider');
        if (subscribeslider.length > 0 && !initMeixcoSplide) {
            new Splide('.mexico-box-slider', {
                autoplay: false,
                type: 'slide',
                width: '100%',
                fixedHeight: 480,
                gap: 0,
                pagination: true,
                perPage: 1,
                focus: 'center',
                trimSpace: true,
                arrows: false,
                cover: true,
                rewind: true,
                breakpoints: {
                    749: {
                        trimSpace: false,
                        fixedHeight: 375,
                        pagination: true
                    }
                }
            }).mount();
            initMeixcoSplide = true;
        }
        window.dispatchEvent(new Event('resize'));
    }

    if (e.target.classList.contains('modal-open') && e.target.getAttribute('data-id') == 'ramen-box-modal') {
        var subscribeslider = document.getElementsByClassName('ramen-box-slider');
        if (subscribeslider.length > 0 && !initRamenSplide) {
            new Splide('.ramen-box-slider', {
                autoplay: false,
                type: 'slide',
                width: '100%',
                fixedHeight: 480,
                gap: 0,
                pagination: true,
                perPage: 1,
                focus: 'center',
                trimSpace: true,
                arrows: false,
                cover: true,
                rewind: true,
                breakpoints: {
                    749: {
                        trimSpace: false,
                        fixedHeight: 375,
                        pagination: true
                    }
                }
            }).mount();
            initRamenSplide = true;
        }
        window.dispatchEvent(new Event('resize'));
    }
});

const openModal = (modal) => {
    document.body.style.overflow = "hidden";
    modal.setAttribute("open", "true");
    document.addEventListener("keydown", escClose);
    let overlay = document.createElement("div");
    overlay.id = "modal-overlay";
    document.body.appendChild(overlay);
};

const closeModal = (modal) => {
    document.body.style.overflow = "auto";
    modal.removeAttribute("open");
    document.removeEventListener("keydown", escClose);
    document.body.removeChild(document.getElementById("modal-overlay"));
};

const escClose = (e) => {
    if (e.keyCode == 27) {
        closeModal();
    }
};

// Function to be executed when the page loads
function checkQueryString() {
    // Check if the modal has already been triggered this session
    if (sessionStorage.getItem('modalTriggered')) {
        return; // Exit the function if the modal was already triggered
    }

    // Create a URLSearchParams object based on the current URL
    const params = new URLSearchParams(window.location.search);

    // Check if the 'adv' parameter is present
    if (params.has('adv')) {
        const advValue = params.get('adv');

        // Mark that the modal has been triggered
        sessionStorage.setItem('modalTriggered', 'true');

        // Find the link element by its ID
        const linkElement = document.getElementById('cart-loader-link');

        // Change the href of the link, appending the 'adv' value
        linkElement.href = `https://munchaddict.com/adv-${advValue}`;

        // Run the openModal function with the specified argument
        modal = document.getElementById('cart-loader-modal');
        openModal(modal);

        //Track Cart Loader Open
        dataLayer.push({'event': 'cartLoaderViewed', 'label': advValue });
    }
}

// Ensure the checkQueryString function runs when the document is ready
document.addEventListener('DOMContentLoaded', checkQueryString);

function handlePreloadCart() {
    const params = new URLSearchParams(window.location.search);

    // Check if the 'adv' parameter is present
    if (params.has('adv')) {
        const advValue = params.get('adv');

        //Track Cart Loader Open
        dataLayer.push({'event': 'cartLoaderClick', 'label': advValue });
    }
}